import { canv } from "@/canv/global";
import type { TouchEventStructure } from "./types";

export class TouchEvent {
    event: TouchEventStructure;

    constructor(UID: string) {
        this.event = {
            type: "touch",
            UID,
        };
    }

    execEvent() {}

    checkEvent() {
        const entity = canv.canvasController.FindByUID(this.event.UID);

        if (entity == null) {
            return false;
        }

        return true;
    }

    getEvent() {
        return this.event;
    }

    loadEvent(event: TouchEventStructure) {
        this.event = event;
    }

    getTwin() {
        const twin = new TouchEvent(this.event.UID);

        return twin;
    }
}
